import { z } from 'zod';

export enum FileReferenceType {
  ExternalDocumentPacket = 'externalDocumentPacket',
  FhirDocument = 'fhirDocument',
  Document = 'document',
  HumanTaskAsset = 'humanTaskAsset',
  NotableClassicJobScreenshot = 'notableClassicJobScreenshot',
  VoiceCall = 'voiceCall',
}

export const FileReferenceDataSchema = z.object({
  type: z.enum(FileReferenceType),
  ehrInformationId: z.string().nullish(),
  practiceId: z.string().nullish(),
  organizationId: z.string().nullish(),
  gsPath: z.string(),
});
export type FileReferenceData = z.infer<typeof FileReferenceDataSchema>;

export const FileReferenceUrlSchema = z.object({
  signedReadUrl: z.string(),
});
export type FileReferenceUrl = z.infer<typeof FileReferenceUrlSchema>;

export const FileReferenceSchema = z.object({
  fileReference: z.string(),
});

export type FileReference = z.infer<typeof FileReferenceSchema>;
